{
  "version": 1,
  "asset_id": "8783cbdb-9aa8-4c64-80d8-d0a012272dab",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/8783cbdb-9aa8-4c64-80d8-d0a012272dab/electrical-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/8783cbdb-9aa8-4c64-80d8-d0a012272dab/electrical-thumb.webp",
  "original_filename": "electrical-thumb.webp",
  "size": 7808,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:03Z"
}
